// front-end/src/components/navigation/navigation.js

function updateHeaderHeight() {
    const header = document.querySelector('bml-header');
    if (!header) return;
    // Не міряємо, коли відкрите мобільне меню — collapse роздуває висоту хедера
    const collapse = document.getElementById('navbarSupportedContent');
    if (collapse && (collapse.classList.contains('show') || collapse.classList.contains('collapsing'))) return;
    const h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-h', Math.ceil(h) + 'px');
}

// Позиція елемента в layout без урахування transform (fade-up зсуває блок
// на translateY(40px), через що scrollIntoView промахується)
function layoutTop(el) {
    let y = 0;
    while (el) {
        y += el.offsetTop;
        el = el.offsetParent;
    }
    return y;
}

function headerOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-h');
    const h = parseInt(raw, 10);
    return (Number.isFinite(h) ? h : 100) + 16;
}

function scrollToTarget(target, smooth = true) {
    updateHeaderHeight();
    const top = Math.max(0, layoutTop(target) - headerOffset());
    window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
}

// Після завантаження сторінки з #hash контент догружається динамічно і зсуває
// блок — доскролюємо, поки позиція не стабілізується або користувач не втрутиться
function settleScrollToHash() {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    let target;
    try { target = document.querySelector(hash); } catch { return; }
    if (!target) return;

    let userInterrupted = false;
    const interrupt = () => { userInterrupted = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(ev =>
        window.addEventListener(ev, interrupt, { once: true, passive: true })
    );

    let attempts = 0;
    let lastTop = null;
    const tick = () => {
        if (userInterrupted) return;
        const top = layoutTop(target);
        if (lastTop === null || Math.abs(top - lastTop) > 2) {
            scrollToTarget(target, false);
        }
        lastTop = top;
        if (++attempts < 10) setTimeout(tick, 300);
    };
    setTimeout(tick, 100);
}

export function initNavigation() {
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    window.addEventListener('orientationchange', () => setTimeout(updateHeaderHeight, 200));
    window.addEventListener('load', () => { updateHeaderHeight(); settleScrollToHash(); });
    settleScrollToHash();
    // ── Mobile: Bootstrap collapse ──────────────────────────────────────────
    const navbarCollapse = document.getElementById('navbarSupportedContent');
    const togglerBtn     = document.querySelector('header .navbar-toggler');
    const closeBtn       = document.querySelector('.close-burger-btn');

    // ── Desktop: Side drawer ────────────────────────────────────────────────
    const drawerToggle  = document.getElementById('drawer-toggle');
    const drawerClose   = document.getElementById('drawer-close');
    const drawerOverlay = document.getElementById('drawer-overlay');
    const sideDrawer    = document.getElementById('side-drawer');

    function isMobile() {
        return window.innerWidth < 768;
    }

    // ── Mobile button state ─────────────────────────────────────────────────
    function updateMobileButtons() {
        if (!navbarCollapse || !togglerBtn || !closeBtn) return;

        if (!isMobile()) {
            togglerBtn.style.setProperty('display', 'none', 'important');
            closeBtn.style.setProperty('display', 'none', 'important');
            if (navbarCollapse.classList.contains('show')) {
                const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
                if (bsCollapse) bsCollapse.hide();
            }
            return;
        }

        const isOpen = navbarCollapse.classList.contains('show') ||
                       navbarCollapse.classList.contains('collapsing');

        if (isOpen) {
            togglerBtn.style.setProperty('display', 'none', 'important');
            closeBtn.style.setProperty('display', 'block', 'important');
        } else {
            togglerBtn.style.setProperty('display', 'block', 'important');
            closeBtn.style.setProperty('display', 'none', 'important');
        }
    }

    // ── Desktop drawer ──────────────────────────────────────────────────────
    function openDrawer() {
        sideDrawer?.classList.add('is-open');
        drawerOverlay?.classList.add('is-visible');
        document.body.classList.add('drawer-open');
    }

    function closeDrawer() {
        sideDrawer?.classList.remove('is-open');
        drawerOverlay?.classList.remove('is-visible');
        document.body.classList.remove('drawer-open');
    }

    // ── Wire up mobile ──────────────────────────────────────────────────────
    if (navbarCollapse && togglerBtn && closeBtn) {
        updateMobileButtons();

        togglerBtn.addEventListener('click', () => setTimeout(updateMobileButtons, 0));

        closeBtn.addEventListener('click', () => {
            const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse) ||
                               new bootstrap.Collapse(navbarCollapse);
            bsCollapse.hide();
            setTimeout(updateMobileButtons, 0);
        });

        navbarCollapse.addEventListener('show.bs.collapse', updateMobileButtons);
        navbarCollapse.addEventListener('hide.bs.collapse', updateMobileButtons);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((m) => {
                if (m.attributeName === 'class') requestAnimationFrame(updateMobileButtons);
            });
        });
        observer.observe(navbarCollapse, { attributes: true, attributeFilter: ['class'] });
    }

    // ── Wire up desktop drawer ──────────────────────────────────────────────
    drawerToggle?.addEventListener('click', openDrawer);
    drawerClose?.addEventListener('click', closeDrawer);
    drawerOverlay?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeDrawer();
    });

    // ── Resize: sync both mechanisms ────────────────────────────────────────
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            updateMobileButtons();
            if (!isMobile()) closeDrawer();
        }, 100);
    });

    // ── Same-page anchor links: close menu first, then scroll ───────────────
    document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href*="#"]');
        if (!link) return;

        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        if (url.pathname !== window.location.pathname) return;
        if (!url.hash || url.hash.length < 2) return;

        let target;
        try { target = document.querySelector(url.hash); } catch { return; }
        if (!target) return;

        e.preventDefault();
        history.pushState(null, '', url.hash);

        const menuOpen = navbarCollapse?.classList.contains('show');
        const drawerOpen = sideDrawer?.classList.contains('is-open');

        if (menuOpen && navbarCollapse) {
            const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse) ||
                               new bootstrap.Collapse(navbarCollapse);
            bsCollapse.hide();
        }
        if (drawerOpen) closeDrawer();

        // Чекаємо завершення анімації закриття меню, потім скролимо
        const delay = (menuOpen || drawerOpen) ? 400 : 0;
        setTimeout(() => scrollToTarget(target), delay);
    });

    console.log('Navigation initialized');
}

export function hasNavigation() {
    return document.getElementById('navbarSupportedContent') !== null;
}
